import * as React from 'react';
import { useHistory } from 'react-router';
import { ApiClient } from '../utils/ApiClient';
import { Button } from '../components/Button';
import { APP_NAME } from '../Const';
import './LoginPage.css';

interface ILoginPageState {
  inputId: string;
  inputPassword: string;

  // ログイン中かどうか
  isLoggingIn: boolean;

  // ログインしたかどうか
  authorized: boolean;
}

interface ILoginPageProps {}

export const LoginPage: React.FC<ILoginPageProps> = function () {
  const history = useHistory();
  const [state, setState] = React.useState<ILoginPageState>({
    inputId: '',
    inputPassword: '',
    isLoggingIn: false,
    authorized: false,
  });
  const [loginFailed, setLoginFailed] = React.useState(false);

  async function login() {
    setState((prev) => ({ ...prev, isLoggingIn: true }));
    setLoginFailed(false);

    let authorized = false;
    try {
      const apiClient = new ApiClient();

      await apiClient.login({
        screen_id: state.inputId,
        password: state.inputPassword,
      });

      authorized = true;
    } catch (error) {
      setLoginFailed(true);
    } finally {
      setState((prev) => ({
        ...prev,
        authorized,
        isLoggingIn: false,
      }));
    }
  }

  if (state.authorized) {
    history.push('/');
  }

  let errorMessage;
  if (loginFailed) {
    errorMessage = (
      <p className="LoginPage-error" role="alert">
        ログインに失敗しました。ログインIDとパスワードを確認してください。
      </p>
    );
  }

  let buttonLabel = 'ログイン';
  if (state.isLoggingIn) {
    buttonLabel = 'ログイン中...';
  }

  return (
    <form
      className="LoginPage-login_container"
      onSubmit={(event) => {
        // ブラウザ既定の送信（画面の再読み込み）を止め、APIでログインする
        event.preventDefault();
        if (state.isLoggingIn) {
          return;
        }
        login();
      }}
    >
      <div className="LoginPage-title_container">
        <h1 className="LoginPage-title">{APP_NAME}</h1>
      </div>
      {errorMessage}
      <div className="LoginPage-id_container">
        <label className="LoginPage-label" htmlFor="LoginPage-login_id">
          ログインID
        </label>
        <input
          id="LoginPage-login_id"
          className="LoginPage-login_id_input"
          type="text"
          name="username"
          autoComplete="username"
          onChange={(event) => {
            const inputId = event.target.value;
            setState((prev) => ({ ...prev, inputId }));
          }}
          value={state.inputId}
        />
      </div>
      <div className="LoginPage-password_container">
        <label className="LoginPage-label" htmlFor="LoginPage-login_password">
          パスワード
        </label>
        <input
          id="LoginPage-login_password"
          className="LoginPage-login_password_input"
          type="password"
          name="password"
          autoComplete="current-password"
          onChange={(event) => {
            const inputPassword = event.target.value;
            setState((prev) => ({ ...prev, inputPassword }));
          }}
          value={state.inputPassword}
        />
      </div>
      <div className="LoginPage-login_button_container">
        <Button
          type="submit"
          className="LoginPage-login_button"
          disabled={state.isLoggingIn}
        >
          {buttonLabel}
        </Button>
      </div>
    </form>
  );
};
